import styled from 'styled-components';

export const ContainerNeedHelp = styled.div`
  max-width: 1139px;
  max-height: 95vh;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 8px;
  * {
    box-sizing: border-box;
  }
  .container-infos {
    display: flex;
    gap: 6px;

    .form-need-help {
      padding: 40px;
      min-width: fit-content;
      width: 100%;
      display: grid;

      gap: 24px;
      max-height: 95vh;
      box-sizing: border-box;
      overflow: auto;

      a {
        color: #003da5;
        font-weight: bold;
      }
      .container-buttons-need-help {
        display: flex;
        flex-direction: column;
        gap: 24px;
      }
    }
  }

  .diana-need-help-desktop {
    max-height: 95vh;
    width: 100%;
  }

  @media (min-width: 1000px) {
    .form-need-help {
      &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        border-radius: 10px;
        background-color: transparent;
        opacity: 0.7;
        margin-top: 8px;
        margin-bottom: 8px;
      }

      &::-webkit-scrollbar {
        width: 12px;
        background-color: transparent;
        opacity: 0.7;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        background-color: #d2d2d2;
        opacity: 0.5;
      }
    }
  }

  @media (max-width: 1000px) {
    width: 100vw;
    box-sizing: border-box;
    border-radius: unset;
    min-height: 100vh;
    max-height: 100%;

    .container-infos {
      .form-need-help {
        min-height: 100%;
        max-height: 100%;
        width: 100%;
        overflow: hidden;
        align-self: flex-start;
      }
    }
  }
`;
